import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import UnifiedProjectHeader from "components/UnifiedProject/UnifiedProjectHeader";

import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";

import * as consumerReducer from "containers/Consumer/reducer";
import * as nextReducer from "containers/Next/NextReducer";

class UnifiedProjectHeaderContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {} = this.props;

    return <UnifiedProjectHeader {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateCurrentStep: (stepId) => dispatch(unifiedProjectReducer.updateCurrentStep(ownProps.id, stepId)),
    updateLabel: (label) => dispatch(setupReducer.updateLabel(ownProps.id, label)),
    updateProjectName: (name) => dispatch(projectReducer.updateProjectName(ownProps.id, name)),
    updateIsEditBlueprint: (value) => dispatch(unifiedProjectReducer.updateIsEditBlueprint(ownProps.id, value)),
    updateIsAudit: (isAudit) => dispatch(unifiedProjectReducer.updateIsAudit(ownProps.id, isAudit)),
    saveBlueprint: () => dispatch(unifiedProjectReducer.saveBlueprint(ownProps.id)),
    getBlueprint: (blueprintId) => dispatch(unifiedProjectReducer.getBlueprint(blueprintId)),

    updateProjectId: (projectId) => dispatch(consumerReducer.updateProjectId(projectId))
  };
};

const mapStateToProps = (state, ownProps) => {
  const blueprintId =
    ownProps.id === "new"
      ? setupReducer.getBlueprintId(state, ownProps.id)
      : projectReducer.getBlueprintId(state, ownProps.id);

  return {
    isEditBlueprint: unifiedProjectReducer.getIsEditBlueprint(state, ownProps.id),
    isForecast: projectReducer.getIsForecastProject(state, ownProps.id),
    isSavingBlueprint: unifiedProjectReducer.getIsSavingBlueprint(state, ownProps.id),
    isAudit: unifiedProjectReducer.getIsAudit(state, ownProps.id),
    currentStep: unifiedProjectReducer.getCurrentStep(state, ownProps.id),
    label:
      ownProps.id === "new" ? setupReducer.getLabel(state, "new") : projectReducer.getProjectName(state, ownProps.id),
    createdDate: projectReducer.getCreatedDate(state, ownProps.id),
    hasSplits: projectReducer.getHasSplits(state, ownProps.id),

    blueprintId: blueprintId,
    blueprint: blueprintReducer.getBlueprint(state, blueprintId),

    nextId: ownProps?.match?.params?.nextId ?? nextReducer.getNextIdFromProjectId(state, Number(ownProps.id))
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(UnifiedProjectHeaderContainer);
